module.exports = __webpack_public_path__ + "img/center-2017-belt-road.47d2cbe5.jpg";